import { View, Text } from "react-native";
import React from "react";
import { TouchableOpacity } from "react-native-web";
import Collection from "../components/Collection";
import EnuCollection from "../components/nuCollection";

const nuStore = ({ navigation, route }) => {
  return (
    <View>
      <TouchableOpacity onPress={() => console.log(route.params)}>
        <Text>nuStore</Text>
      </TouchableOpacity>
      <EnuCollection products={route.params} type={false} />
    </View>
  );
};

export default nuStore;
